import { render, staticRenderFns } from "./CustomersTypesFunnelGraph.vue?vue&type=template&id=28b85466&scoped=true"
import script from "./CustomersTypesFunnelGraph.vue?vue&type=script&lang=js"
export * from "./CustomersTypesFunnelGraph.vue?vue&type=script&lang=js"
import style0 from "./CustomersTypesFunnelGraph.vue?vue&type=style&index=0&id=28b85466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b85466",
  null
  
)

export default component.exports